import React from "react";
import { useState } from "react";
import { DeleteTwoTone} from "@material-ui/icons";
import { useEffect } from "react";
import { calculateBuyAmount } from "./AdjustmentService";
import { formatValidInput, formatValidSelect } from "../../../helpers/FormatHelper";
import NumberInput from "../../shared/NumberInput";
import DynamicSelect from "../../shared/DynamicSelect";

export function AdjustmentRow({rowObject, rowID, currenciesList, currencyPairs, adjustmentTypeList, buyScale, onDeleteRow, onUpdateFieldRow, validations, onUpdateRowAmounts, autoFocus}){

    const [amount, setAmount] = useState(0);
    const [buyAmount, setBuyAmount] = useState(0);
    const [costRate, setCostRate] = useState(0);
    const [ratePrecision, setRatePrecision] = useState(0);
    const [rateTerms, setRateTerms] = useState('D');
    const [currencyID, setCurrencyID] = useState('');
    const [comments, setComments] = useState('');
    const [adjustmentType, setAdjustmentType] = useState('');
    const [sellScale, setSellScale] = useState(2);  

    useEffect(() => {
    if (rowObject.CurrencyID){     
        setCurrencyID(rowObject.CurrencyID);
        setRatePrecision(rowObject.RatePrecision);
        setRateTerms(rowObject.RateTerms);     
        setAmount(rowObject.Amount);
        setComments(rowObject.Comments);
        setCostRate(rowObject.CostRate);
        setAdjustmentType(rowObject.AdjustmentType);
        setBuyAmount(rowObject.BuyAmount);
        setSellScale(rowObject.CurrencyScale);
    }
  }, [rowObject, currenciesList]);


    const dropdownCurrenciesChangeHandler = (item) =>
    {
       if(item.value && item.value !== '')
        { 
            const ccyPair = currencyPairs.find(ccy => ccy.OutCurrencyCode === item.value);

            if(ccyPair)
            {
                setRatePrecision(ccyPair.RatePrecision);
                setRateTerms(ccyPair.RateTerms);            

                setCurrencyID(item.value);
            
                setBuyAmount(0);
                setCostRate(0);
                setAmount(0);
                
                onUpdateFieldRow(rowID, 'CurrencyID', item.value);
                onUpdateFieldRow(rowID, 'CurrencyName', item.name);
                onUpdateFieldRow(rowID, 'CurrencyScale', item.NumberOfDecimals);
                onUpdateRowAmounts(rowID, 0, 0, 0, ccyPair.RatePrecision,ccyPair.RateTerms);
            }
            
        }
    
    }

    const onBlurAmount = async() =>{
        
        const orderRowAux = JSON.parse(JSON.stringify(rowObject))
        onUpdateFieldRow(rowID, 'Amount', Number(amount));
        if(orderRowAux.CostRate > 0)
        {
            const amountByCostRate = calculateBuyAmount(rateTerms, orderRowAux.CostRate, amount, buyScale);
            setBuyAmount(amountByCostRate);
            onUpdateFieldRow(rowID, 'BuyAmount', amountByCostRate);
        }
        else
        {
            setBuyAmount(0);
            onUpdateFieldRow(rowID, 'BuyAmount', 0);
        }
    }

    const onDeleteOrderRow = () => {
      onDeleteRow(rowID);
    };
  

    const onBlurCostRate = ()=>{        
          
        const orderRowAux = JSON.parse(JSON.stringify(rowObject))
        const amountByCostRate = calculateBuyAmount(rateTerms, costRate, orderRowAux.Amount, buyScale);
        
        setBuyAmount(amountByCostRate);
        onUpdateFieldRow(rowID, 'CostRate', costRate);
        onUpdateFieldRow(rowID, 'BuyAmount', amountByCostRate);
    }

    const onCommentsChange = (e) => {
        if(e.target.value)
        {
            setComments(e.target.value);
            onUpdateFieldRow(rowID, 'Comments',e.target.value);
        }
    };

    const dropdownAdjustmentTypeChangeHandler = (item) =>
    {
       if(item.value && item.value !== '-1')
      { 
            setAdjustmentType(item.value);
            onUpdateFieldRow(rowID, 'AdjustmentType', item.value);
      }
    }

    return <>
    <tr key={rowID}>
        <td>
            <DynamicSelect
              className={formatValidSelect(validations.CurrencyID)}
              id={`dd-currencies-${rowID}`}
              key={`dd-currencies-${rowID}`}
              data={currenciesList}
              getValue={dropdownCurrenciesChangeHandler}
              objValue={{ value: currencyID }}
              placeholder={'Select currency...'}
              autoFocus={autoFocus}
            />
        </td>
        <td>
            <DynamicSelect
              className={formatValidSelect(validations.AdjustmentType)}
              id={`dd-profitloss-${rowID}`}
              key={`dd-profitloss-${rowID}`}
              data={adjustmentTypeList}
              getValue={dropdownAdjustmentTypeChangeHandler}
              objValue={{ value: adjustmentType }}
            />
        </td>
        <td>
            <NumberInput id={`txt-amount-${rowID}`} key={`txt-amount-${rowID}`} className={formatValidInput(validations.Amount)} value={amount} 
            onBlur={onBlurAmount} onChange ={(event) => {setAmount(event.target.value);}} scale={sellScale} type="Currency" />
        </td>
        <td>
            <NumberInput id={`costrate-${rowID}`} key={`costrate-${rowID}`} className={formatValidInput(validations.CostRate)} value={costRate} 
                    scale={ratePrecision} onBlur={onBlurCostRate} onChange ={(event) => {setCostRate(event.target.value);}} type="Rate"/>
        </td>
        
        <td>
            <NumberInput id={`buyAmount-${rowID}`} key={`buyAmount-${rowID}`} className={formatValidInput(validations.BuyAmount)} value={buyAmount} 
            onChange ={(event) => {setBuyAmount(event.target.value);}} scale={buyScale} disabled={true} type="Currency" />
        </td>
        
        <td>
            <textarea id={`comments-${rowID}`} key={`comments-${rowID}`} className='uk-textarea' value={comments} onChange={onCommentsChange} />  
        </td>
        <td>
            <DeleteTwoTone id={`delete-row-${rowID}`} key ={`delete-row-${rowID}`} style={{ marginRight: '20px', marginTop: '10px' }} onClick={onDeleteOrderRow} twoToneColor="#34c521"  />
        </td>

    </tr>
    </>

}

export default AdjustmentRow